import { getApiBase } from "@/lib/api-client";

// Checklist items
export const CHECKLIST_ITEMS = [
  "Gesamtansicht der Fassade",
  "Dachflächen und Dachentwässerung (Dachrinnen, Fallrohre)",
  "Fenster und Außentüren in Gemeinschaftsbereichen",
  "Haustüranlage u. Eingangsbereich",
  "Treppenhauszustand (Wände, Decken, Bodenbeläge, Geländer, Handläufe)",
  "Beleuchtung in Gemeinschaftsflächen",
  "Heizungsanlage, wenn vorhanden (Betriebszustand, Wartungsnachweise)",
  "Elektro-Hauptverteilung und Allgemeinstrom",
  "Wasserfilter/Absperrventile",
  "Brandschutzeinrichtungen (Rauchwarnmelder in Gemeinschaftsflächen, Feuerlöscher)",
  "Aufzugsanlage (Sichtprüfung), wenn vorhanden",
  "Standplatz Mülltonnen",
  "Befestigte Außenanlagen wie Hof, Wege, Zufahrten und deren Beleuchtung",
  "Grünanlagen und Baumbestand",
  "Spielplätze sofern vorhanden",
  "Tiefgarage / Garagen / Stellplätze",
  "Fahrrad- und Kinderwagenräume, wenn vorhanden",
  "Sauberkeit und Ordnung der Gemeinschaftsflächen",
  "Hinweise auf Vandalismus oder Beschädigungen",
  "Einhaltung der Hausordnung",
];

// Special options for "Gesamtansicht der Fassade" - ALL CAPS
export const FASSADE_OPTIONS = [
  "INSGESAMT OK",
  "BAUJAHRESENTSPRECHEND",
  "LEICHT VERWITTERT",
  "VERWITTERT UND LEICHT BESCHÄDIGT",
  "REINIGUNG EMPFOHLEN",
  "ANSTRICH EMPFOHLEN",
  "AUSBESSERUNGEN + ANSTRICH NOTWENDIG",
  "TLW. BESCHÄDIGT",
  "GROSSFLÄCHIG BESCHÄDIGT",
  "WIE NEU"
];

// General options for all checklist items
export const GENERAL_CHECKLIST_OPTIONS = [
  { value: "NICHT_KONTROLLIERT", label: "NICHT KONTROLLIERT", color: "gray" },
  { value: "NICHT_ZUGÄNGLICH", label: "NICHT ZUGÄNGLICH", color: "blue" },
  { value: "NICHT_VORHANDEN", label: "NICHT VORHANDEN", color: "green" },
  { value: "SCHADEN_MANGEL_FESTGESTELLT", label: "SCHADEN/MANGEL FESTGESTELLT", color: "red" }
];

export const API = getApiBase();
